<template>
  <v-main>

          <v-card class="elevation-12 mx-auto mt-1" max-width="550" elevation="0">
      
            <p class="text-center red--text text-h5 mt-6">Create Account</p>
            
            <section class="d-flex justify-center">
              <p class="ma-4 styled-font text-center">Create an account</p>
              
              <v-btn color="secondary" class="ma-2" fab x-small @click="openInfo">
                <v-icon>mdi-information-variant</v-icon>
              </v-btn>
            </section>
               <Alert />
            <v-card-text v-if="!registered">
              <v-form ref="form" v-model="valid" lazy-validation @keyup.native.enter="register">
                <v-text-field
                  label="Email"
                  v-model="userdetails.email"
                  :rules="emailRules"
                  name="login"
                  prepend-icon="mdi-email"
                  type="email"
                  rounded
                  dense
                  outlined
                />
                <v-text-field
                  label="Password"
                  v-model="userdetails.password"
                  name="login"
                  prepend-icon="mdi-lock"
                  :rules="passwordRules"
                  type="password"
                  rounded
                  dense
                  outlined
                />
                <v-text-field
                  label="Confirm Password"
                  v-model="userdetails.password_confirmation"
                  name="login"
                  prepend-icon="mdi-lock"
                  :rules="passwordConfirmRules"
                  type="password"
                  rounded
                    dense
                    outlined
                />
                <v-spacer />
                <v-checkbox v-model="createCheck" label="Create profile"></v-checkbox>
                
                <v-text-field
                  label="firstname"
                  :disabled="addProfile"
                  name="login"
                  prepend-icon="mdi-account"
                  v-model="userdetails.firstname"
                  required
                  :rules="ruleFirstname"
                  type="text"
                  rounded
                  dense
                  outlined
                />
                <v-text-field
                  label="surname"
                  :disabled="addProfile"
                  v-model="userdetails.surname"
                  :rules="ruleSurname"
                  name="login"
                  prepend-icon="mdi-account"
                  type="text"
                  required
                  rounded
                  dense
                  outlined
                />

                <v-text-field
                  label="Date of birth"
                  :disabled="addProfile"
                  v-model="userdetails.date_of_birth"
                  :rules="ruleDateOfBirth"
                  name="login"
                  prepend-icon="mdi-calendar"
                  required
                  type="date"
                  rounded
                  dense
                  outlined
                />
              </v-form>
            </v-card-text>
            <v-card v-else width="100%" class="my-3" color="secondary lighten-2">
                <h3 class="pa-4">Your account registration was successful<br>Further Steps</h3>
                
                <v-card v-for="(item, i) in furtherSteps" :key="i" class="my-3 my-3 text-wrap ">
                  <v-card-text v-html="item" class="text-h5"></v-card-text>
                </v-card>
                <!-- <v-list-item v-for="(item, i) in furtherSteps" :key="i">
                <v-list-item-content class="text-wrap">
                  <v-list-item-title v-html="item">{{ item }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item> -->
              
            </v-card>
            <v-card-actions>
              <v-btn class="buttons white--text" v-if="!registered" rounded @click="register" >Register</v-btn>
              <v-spacer />
              <router-link to="login">Back to Login</router-link>
            </v-card-actions>
          </v-card>
          <RegistrationInfo ref="info"/>
        <!-- </v-col>
      </v-row>
    </v-container> -->
  </v-main>
</template>

<script>
import RegistrationInfo from "./RegistrationInfo";
import Alert from "../templates/Alert"
import { mapGetters } from "vuex";
export default {
  name: "signup",
  data() {
    return {
      registered: false,
      toolbarTitle: "Register",
      valid: true,
      createCheck: false,
      addProfile: true,
      errors: [],
      userdetails: {
        firstname: "",
        surname: "",
        email: "",
        date_of_birth: "",
        password: "",
        password_confirmation: "",
        addProfile: false
      },
      furtherSteps: [
        "1. Please go to your email account to verify your email address.<br> (You might need to check your spam folder if you cannot find it in your inbox)",
        "2. Then log into your mi-sos account",
        "3. Select a required profile or create a new profile",
        "4. If prompted, subscribe using paypal to access your account"
      ],

      passwordConfirmRules: [
        v => !!v || "Password is required",
        v => (v && v.length >= 8) || "Name must be greater than 7 characters",
        v => (!!v && v) === this.userdetails.password || "Passwords do not match"
      ],
      passwordRules: [
        v => !!v || "Password is required",
        v => (v && v.length >= 8) || "Name must be greater than 7 characters"
      ],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ]
    };
  },
  watch: {
    createCheck(val) {
      if (val) {
        this.addProfile = false;
        this.userdetails.addProfile = true;
      } else {
        this.addProfile = true;
        this.userdetails.addProfile = false;
      }
    }
  },
  methods: {
    setEnable() {
      if (this.createCheck) {
        this.addprofile = true;
      } else {
        this.addprofile = false;
      }
    },
    clearErrors() {
      this.errors = [];
    },
    register() {
      //clear errors
      //this.clearErrors();
      if (this.$refs.form.validate()) {
        this.$store.dispatch("userauth/aRegisterUser", this.userdetails)
        .then(response => {
          this.toolbarTitle = "Registration Complete!"
          if (response) this.registered = true
        })
        
      }
    },
    openInfo() {
      this.$refs.info.openDialog();
    }
  }, //computed: mapGetters(['requestErrors']),
  created: function() {
    //this.$store.dispatch('clearError')
    this.$store.commit("mClearMessage");
  },
  components: {
    RegistrationInfo,
    Alert
  },
  computed: {
    createProfile() {
      return !this.userdetails.addProfile;
    },
    ...mapGetters(["getMessage", "getMessages"]),
    ruleFirstname() {
      const rules = [];
      if (this.createCheck) {
        const rule = v => !!v || "Password is required"
        rules.push(rule)
      }
      return rules;
    },
    ruleSurname() {
      const rules = [];
      if (this.createCheck) {
        const rule = v => !!v || "Password is required"
        rules.push(rule)
      }
      return rules;
    },
    ruleDateOfBirth() {
      const rules = [];
      if (this.createCheck) {
        const rule = v => !!v || "Password is required"
        rules.push(rule)
      }
      return rules;
    }
  }
};
</script>

<style>
</style>